module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/tools/select2/select2-groups/select2-groups.component.scss
// module id = ./src/app/components/tools/select2/select2-groups/select2-groups.component.scss
// module chunks = main